// eslint-disable-next-line no-restricted-imports
import { NextjsOptions } from '@sentry/nextjs/esm/utils/nextjsOptions';

export const getOptions = (options: NextjsOptions): NextjsOptions => {
  const overrides: NextjsOptions = {};
  // When we're developing locally
  if (process.env.NODE_ENV !== 'production' && process.env.NEXT_PUBLIC_ACTIVATE_SENTRY !== 'true') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const sentryTestkit = require('sentry-testkit');
    const { sentryTransport } = sentryTestkit();

    // Don't actually send the errors to Sentry
    overrides.transport = sentryTransport;

    // Instead, dump the errors to the console
    overrides.beforeSend = (event, hint) => {
      const error = hint?.originalException || hint?.syntheticException;
      if (error) {
        // eslint-disable-next-line no-console
        console.trace(error);
      }
      return event;
    };

    overrides.defaultIntegrations = false;
  }
  return {
    ...options,
    ...overrides,
  };
};
